(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-tabs"] && !Shopify.designMode) return;
  try {
    
  class CollectionTabs extends HTMLElement {
    connectedCallback() {
      this.tabs   = this.querySelectorAll('.collection-tabs__tab');
      this.panels = this.querySelectorAll('.collection-tabs__panel');

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activate(tab));
      });
    }

    activate(activeTab) {
      const target = activeTab.dataset.tab;

      this.tabs.forEach((tab) => {
        const isActive = tab.dataset.tab === target;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive);
      });

      this.panels.forEach((panel) => {
        const isActive = panel.id.endsWith('-' + target);
        panel.classList.toggle('is-active', isActive);
        isActive ? panel.removeAttribute('hidden') : panel.setAttribute('hidden', '');
      });
    }
  }

  customElements.define('collection-tabs', CollectionTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["manifeste"] && !Shopify.designMode) return;
  try {
    
  class ManifesteCarousel extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-autoplay]');
      if (!this.grid) return;

      this.interval = null;
      this.isPaused = false;
      this.speed = 1; /* px par frame */

      this.startAutoplay();

      /* Pause au survol / touch */
      this.grid.addEventListener('mouseenter', () => { this.isPaused = true; });
      this.grid.addEventListener('mouseleave', () => { this.isPaused = false; });
      this.grid.addEventListener('touchstart', () => { this.isPaused = true; }, { passive: true });
      this.grid.addEventListener('touchend', () => {
        setTimeout(() => { this.isPaused = false; }, 1200);
      });
    }

    startAutoplay() {
      const tick = () => {
        if (!this.isPaused) {
          this.grid.scrollLeft += this.speed;

          /* Reboucle en douceur quand on arrive à la fin */
          const maxScroll = this.grid.scrollWidth - this.grid.clientWidth;
          if (this.grid.scrollLeft >= maxScroll) {
            this.grid.scrollLeft = 0;
          }
        }
        this.raf = requestAnimationFrame(tick);
      };
      this.raf = requestAnimationFrame(tick);
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.raf);
    }
  }

  customElements.define('manifeste-carousel', ManifesteCarousel);

  } catch(e) { console.error(e); }
})();
})();
